import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { S1DowloadCenterTable } from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

export default function S1DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route index element={<S1DowloadCenterTable />} />
    </Routes>
  );
}
